import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {getServices} from "../../../utils/cms.utils";
import SafeImage from "../../../layout/reusable/SafeImage";

const ServicesMain = () => {
    const [services, setServices] = useState(null);

    useEffect(() => {
        const data = getServices();

        const sorted = Array.isArray(data)
            ? [...data].sort(
                (a, b) => (a.orderNo ?? 0) - (b.orderNo ?? 0)
            )
            : [];

        setServices(sorted);
    }, []);

    if (!services) return null;

    return (
        <div className="services-page section-padding-three">

            {/* ===== INTRO ===== */}
            <div className="services-intro">
                <span className="services-intro__tag">Our Services</span>

                <h2 className="services-intro__title">
                    Solutions Designed to Perform,<br />
                    Built to Last
                </h2>

                <p className="services-intro__desc">
                    We combine expertise, efficiency, and attention to detail to deliver
                    high-quality services that drive real results and long-term value for
                    our clients.
                </p>

                <p className="services-intro__desc services-intro__desc--secondary">
                    Kami menggabungkan keahlian, efisiensi, dan ketelitian untuk menghadirkan
                    layanan berkualitas tinggi yang memberikan hasil nyata serta nilai
                    jangka panjang bagi klien.
                </p>
            </div>

            {/* ===== GRID ===== */}
            <div className="container mt-5">
                <div className="services-grid">

                    {services.map((item) => (
                        <Link
                            key={item.id}
                            to={`/services/${item.id}`}
                            className="services-card__link"
                        >
                            <div className="services-card">

                                {/* IMAGE */}
                                <SafeImage
                                    src={item.image[0]}
                                    alt={item.titleEn}
                                    isCoverImage
                                    className="services-card__image"
                                />

                                {/* OVERLAY */}
                                <div className="services-card__overlay">
                                    <h4 className="services-card__title">
                                        {item.titleEn}
                                    </h4>

                                    {item.titleId && (
                                        <p className="services-card__subtitle">
                                            {item.titleId}
                                        </p>
                                    )}

                                    <span className="services-card__action">
                                        View Service
                                        <i className="flaticon-right-up" />
                                    </span>
                                </div>

                            </div>
                        </Link>
                    ))}

                    {services.length === 0 && (
                        <p className="text-center muted">
                            No services available.
                        </p>
                    )}

                </div>
            </div>
        </div>
    );
};

export default ServicesMain;
